import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { useAuth } from '../hooks/use-auth';

const Profile = () => {
  const { user } = useAuth();

  return (
    <div className='container mx-auto px-4 py-16'>
      <div className='max-w-2xl mx-auto'>
          <h1 className="text-4xl font-bold mb-4">
              Миний профайл
            </h1>
        <form className='space-y-6'>
          <div>
            <Label htmlFor='lastName'>Овог</Label>
            <Input id='lastName' value={user?.lastName} required disabled />
          </div>
          <div>
            <Label htmlFor='firstName'>Нэр</Label>
            <Input id='firstName' value={user?.firstName} disabled required />
          </div>

          <div>
            <Label htmlFor='email'>И-мэйл</Label>
            <Input
              id='email'
              type='email'
              value={user?.email}
              required
              disabled
            />
          </div>

          <div>
            <Label htmlFor='phone'>Утас</Label>
            <Input id='phone' value={user?.phone} required disabled />
          </div>

          {/* <Button type="submit">Хадгалах</Button> */}
        </form>
      </div>
    </div>
  );
};

export default Profile;
